import React from "react"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import SimpleText from "./simpleText"

import "react-tabs/style/react-tabs.css"
import "./offices.scss"

const Offices = props => {
  const { setSelectedOffice } = props

  const handleSelectedOffice = i => {
    const office = props.items[i]
    setSelectedOffice(office)
  }

  return (
    <Tabs onSelect={i => handleSelectedOffice(i)}>
      <TabList>
        {props.items.map(item => (
          <Tab key={`${item._key}_trigger`}>{item.officeName}</Tab>
        ))}
      </TabList>
      <div className="tabsBody">
        {props.items.map(item => (
          <TabPanel key={`${item._key}_target`}>
            <h3>{item.officeName} Office</h3>
            <SimpleText blocks={item.address} />
            {item.telephoneNumber && (
              <ul>
                {item.telephoneNumber.map(tel => (
                  <li key={`office_tel_${tel}`}>
                    <a href={`tel:${tel}`}>{tel}</a>
                  </li>
                ))}
              </ul>
            )}
            {item.email && (
              <ul>
                {item.email.map(e => (
                  <li key={`office_mail_${e}`}>
                    <a href={`mailto:${e}`}>{e}</a>
                  </li>
                ))}
              </ul>
            )}
          </TabPanel>
        ))}
      </div>
    </Tabs>
  )
}

export default Offices
